import { Validators } from '@angular/forms';
import { regex } from '../../../../common/regex.constants';
import { environment } from '../../../../../environments/environment';

export interface PhoneModel {
  editValue: string;
  activationCode: string;
}
export interface PayloadModel {
  phoneNumbers: [
    {
      phoneType: string,
      phoneNumber: string,
      phoneVerified: boolean,
      countryCode: string
    }
  ];
}
export interface VerifyCodeModel {
  purpose: string;
  phone: string;
  sendNotification: boolean;
}
export class Phone {
  public formBindings: PhoneModel;
  constructor(
    public data?: PhoneModel,
  ) { }

  /**
  * @method __defaults Return the defaults values for the model
  * @returns All the values in the EmailModel interface as ''
  **/
  public __defaults(): PhoneModel {
    return this.formBindings = {
      editValue: '',
      activationCode: ''
    };
  }
  /**
  * @method values Return the values send in the data property
  * @returns SignUpModel Interface
  **/
  public get values(): PhoneModel {
    return this.data !== undefined ? this.__formBindings({ ...this.data }) : this.__defaults();
  }
  /**
  * @method __formBindings Returns the values for initialize in case of read mode
  * @returns SignUpModel
  **/
  public __formBindings(bindings: PhoneModel): PhoneModel {
    return {
      'editValue': bindings['editValue'] ? bindings['editValue'] : '',
      'activationCode': bindings['activationCode'] ? bindings['activationCode'] : ''
    };
  }
  /**
  * @function tag returns the translation tag for phone number when called
  * @returns {string}
  **/
  get tag(): string {
    return 'update-account.labels.mobile-number';
  }
  /**
  * @function placeholder returns the translation for phone number when called
  * @returns {string}
  **/
  get placeholder(): string {
    return this.tag;
  }
  /**
  * @function translateParams returns the object for phone number context when called
  * @returns {object}
  **/
  get translateParams(): object {
    return { 'tag': 'Mobile Number' };
  }

  /**
  * @method form Return the form controls to be used in the update-account component
  * @returns Object with the controls
  **/
  public get form(): object {
    return this.customerControls;
  }
  /**
  * @method customerControls Controls for the admin view
  * @returns Object with the required controls
  **/
  public get customerControls(): object {
    return {
      editValue: this.phoneControl,
      activationCode: this.activationCodeControl
    };
  }

  /**
  * @method phoneControlCustomer Controls for phone field when customer and dealer
  * @returns Array of validators
  **/
  public get phoneControl(): any[] {
    return [
      { value: '' },
      [Validators.required,
      Validators.minLength(10),
      Validators.maxLength(14),
      Validators.pattern(regex.phoneNumberPattern)]];
  }
  /**
  * @method activationCodeControl Controls for activationCode field
  * @returns Array of validators
  **/
  public get activationCodeControl(): any[] {
    return [
      { value: '' },
      [Validators.required,
      Validators.minLength(1),
      Validators.maxLength(6),
      Validators.pattern(regex.verificationCode)]
    ];
  }
  /**
  * @function fieldRequired returns the translation for required field validation error of phone number and code when called
  * @returns Array<string>
  **/
  get fieldRequired(): Array<string> {
    return ['sign-up.errors.phone-required', 'sign-up.errors.code-required'];
  }
  /**
  * @function fieldPattern returns the translation for Pattern validation error of phone number and code when called
  * @returns Array<string>
  **/
  get fieldPattern(): Array<string> {
    return ['sign-up.validations.phone-pattern', 'sign-up.validations.code-pattern'];
  }
  /**
  * @function fieldLength returns the translation for maxlength validation error of phone number and code when called
  * @returns Array<string>
  **/
  get fieldLength(): Array<string> {
    return ['sign-up.validations.phone-pattern', 'sign-up.validations.code-pattern'];
  }
  /**
  * @function endPoint returns the endpoint for updatting the email ID
  * @returns {string}
  **/
  get endPoint(): string {
    return environment.admin.apis.customer_update;
  }
  /**
  * @method updateAccount_Payload Returns the phone object when called
  * @returns PayloadModel
  **/
  public updateAccount_Payload(updatedNumber: string, countryCode: string): PayloadModel {
    return {
      phoneNumbers: [
        {
          phoneType: 'MOBILE',
          phoneNumber: updatedNumber,
          phoneVerified: true,
          countryCode: countryCode
        }
      ]
    };
  }
  /**
  * @method verifyCode_Payload Returns the email object when called
  * @returns VerifyCodeModel
  **/
  public verifyCode_Payload(updatedNumber: string, requestCode: boolean): VerifyCodeModel {
    return {
      purpose: requestCode ? 'REQUEST_CODE' : 'ACCOUNT_ACTIVATION',
      phone: updatedNumber,
      sendNotification: true
    };
  }
  /**
  * @method payload Return the payload object of email when called
  * @returns PayloadModel | VerifyCodeModel
  **/
  public payload(updatedNumber: string, type: string, requestCode?: boolean, countryCode?: string): PayloadModel | VerifyCodeModel {
    return type === 'update' ? this.updateAccount_Payload(updatedNumber, countryCode) : this.verifyCode_Payload(updatedNumber, requestCode);
  }
}
